import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";

const MiscItemRow = ({ item, index, dispatch, disabled = false }) => {
	const handleChange = (e) => {
		dispatch({
			type: "UPDATE_MISC_ITEM",
			index,
			field: e.target.name,
			value: e.target.value,
		});
	};

	const handleRemove = () => {
		dispatch({ type: "REMOVE_MISC_ITEM", index });
	};

	return (
		<div className="misc-item-row">
			<div className="misc-item-row__header">
				<span className="misc-item-row__number">Item {index + 1}</span>
				<button
					type="button"
					onClick={handleRemove}
					className="misc-item-row__remove"
					disabled={disabled}
					title="Remove item"
				>
					×
				</button>
			</div>
			<div className="misc-item-row__fields">
				<label className="misc-item-row__field">
					<span className="misc-item-row__label">Description</span>
					<input
						type="text"
						name="description"
						value={item.description}
						onChange={handleChange}
						disabled={disabled}
						className="misc-item-row__input"
						placeholder="Item description"
					/>
				</label>
				<div className="misc-item-row__costs">
					<label className="misc-item-row__field">
						<span className="misc-item-row__label">Cost ($)</span>
						<input
							type="number"
							name="cost"
							value={item.cost}
							onChange={handleChange}
							step="0.5"
							disabled={disabled}
							className="misc-item-row__input"
						/>
					</label>
					<label className="misc-item-row__field">
						<span className="misc-item-row__label">Charge ($ - Opt.)</span>
						<input
							type="number"
							name="charge"
							value={item.charge ?? ""}
							onChange={handleChange}
							step="0.5"
							placeholder="= Cost"
							disabled={disabled}
							className="misc-item-row__input"
						/>
					</label>
				</div>
			</div>
		</div>
	);
};

function MiscSection({ miscItems, fixedCosts, dispatch, FormInput }) {
	const { isAdmin } = useAuth();
	const [isCollapsed, setIsCollapsed] = useState(false);

	const handleAddItem = () => {
		dispatch({ type: "ADD_MISC_ITEM" });
	};

	const toggleCollapse = () => {
		setIsCollapsed(!isCollapsed);
	};

	return (
		<fieldset>
			<legend
				onClick={toggleCollapse}
				style={{
					cursor: "pointer",
					userSelect: "none",
					display: "flex",
					alignItems: "center",
					gap: "8px",
				}}
			>
				<span
					style={{
						transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
						transition: "transform 0.2s ease",
						fontSize: "12px",
					}}
				>
					▼
				</span>
				Extra Misc Costs
			</legend>
			{!isCollapsed && (
				<div>
					{!isAdmin && (
						<p style={{ 
							fontSize: '0.9rem', 
							color: '#666', 
							marginTop: '0.5rem',
							fontStyle: 'italic'
						}}>
							These values are set globally by administrators.
						</p>
					)}
					{/* Fixed Misc Inputs */}
					<FormInput
						label="Equipment Rental ($)"
						field="equipment_rental_cost"
						value={fixedCosts.equipment_rental_cost}
						dispatch={dispatch}
						type="number"
						step="0.5"
						disabled={!isAdmin}
					/>
					<FormInput
						label="Hardware Costs ($)"
						field="hardware_costs"
						value={fixedCosts.hardware_costs}
						dispatch={dispatch}
						type="number"
						step="0.5"
						disabled={!isAdmin}
					/>
					<FormInput
						label="Powder Coating ($)"
						field="powder_coating_costs"
						value={fixedCosts.powder_coating_costs}
						dispatch={dispatch}
						type="number"
						step="0.5"
						disabled={!isAdmin}
					/>
					<FormInput
						label="Fasteners/Screws ($)"
						field="fasteners_screws_costs"
						value={fixedCosts.fasteners_screws_costs}
						dispatch={dispatch}
						type="number"
						step="0.5"
						disabled={!isAdmin}
					/>
					<hr />
					{/* Dynamic Misc Items */}
					{(miscItems || []).map((item, index) => (
						<MiscItemRow
							key={index}
							index={index}
							item={item}
							dispatch={dispatch}
							disabled={!isAdmin}
						/>
					))}
					<button
						type="button"
						onClick={handleAddItem}
						disabled={!isAdmin}
						className="misc-add-button"
					>
						+ Add Misc Item
					</button>
				</div>
			)}
		</fieldset>
	);
}

export default MiscSection;
